'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var contractProductsComponent = exports.contractProductsComponent = {
    template: require('./contract-products.html'),
    bindings: {
        contract: '<'
    },
    controllerAs: 'vm',
    controller: ["$filter", function contractProductsController($filter) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.goToPage = goToPage;
        vm.onProductSearch = onProductSearch;
        vm.onOrderProducts = onOrderProducts;
        vm.pagedContractProducts = [];
        vm.filteredProducts = [];

        function init() {
            vm.pagedContractProducts = vm.contract.getPagedProducts(1, vm.contract.products);
        }

        function onProductSearch() {
            vm.filteredProducts = $filter('filter')(vm.contract.products, function (product) {
                return product.name.toLowerCase().includes(vm.searchValue.toLowerCase()) || product.sellerArticleNumber.toLowerCase().includes(vm.searchValue.toLowerCase());
            });
            vm.pagedContractProducts = vm.contract.getPagedProducts(1, vm.filteredProducts);
            vm.contract.paging.page = 1;
            vm.contract.paging.totalItems = vm.filteredProducts.length;
            vm.contract.paging.update(1);
        }

        function goToPage(page) {
            if (page === 0 || page > vm.contract.paging.pageCount) {
                return;
            }
            vm.pagedContractProducts = vm.contract.getPagedProducts(page, vm.contract.products);
            vm.contract.paging.page = page;
            vm.contract.paging.update(page);
        }

        function onOrderProducts(orderValue) {
            vm.contract.products = $filter('orderBy')(vm.contract.products, orderValue);
            vm.pagedContractProducts = vm.contract.getPagedProducts(1, vm.contract.products);
            vm.contract.paging.page = 1;
            vm.contract.paging.update(1);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/components/contract-products.js
// module id = 836
// module chunks = 0